import axios from "axios";
import { API_URL } from "@/App.settings";
import Vue from "vue";
import Dictionary from "@/types/Dictionary";
import { ConnexionPageState } from "../ConnexionPageState";
import ConnectionMethod from "@/types/ConnectionMethod";
import AuthentificationMethodEnum from "@/enums/AuthentificationMethodEnum";
import { User } from "oidc-client-ts";

/** Etat de gestion d'un oublie de mot de passe */
export class ConnexionPageAuthSso extends ConnexionPageState{
    
    /** Lancement de la procedure d'authentification avec un login SSO OIDC*/
    public async SignIn(): Promise<void> {

        /** Connection classique vie le bouton */
        if(Object.keys(this.context.UrlQueryParameters).length == 0) {
            await this.requestAuth();
        }
        else if(Object.keys(this.context.UrlQueryParameters).length == 1 && this.context.UrlQueryParameters.Login !== undefined){
            /** LOGIN EN GET -> Le login pré-rempli par l'URL suivi de connection OIDC car il ne faut que le login pour initier une connexion OIDC*/
            this.context.Login = this.context.UrlQueryParameters.Login.toString();
            await this.requestAuth();
        }
        else if(Object.keys(this.context.UrlQueryParameters).length > 0 && this.context.UrlQueryParameters.Login === undefined && this.context.UrlQueryParameters.Password === undefined) {
            if(this.context.UrlQueryParameters.token != undefined && this.context.UrlQueryParameters.authority != undefined){
                await this.handleSsoPartnerSignIn();
            }else{
                 /** TOKEN EN GET -> OIDC retourne le token et doit être traité par la lib OIDC */
                await this.handleSsoOidcSignIn();  
            }
        }
    }

    /** Requête l'Idp pour initier une connexion */
    private async requestAuth(): Promise<void>{
        const method: ConnectionMethod = this.context.Vue.$store.getters['AuthentificationStore/GetConnectionMethod'];
        const login: string = this.context.Vue.$store.getters['AuthentificationStore/GetLogin'];
        this.context.Vue.$store.dispatch('OidcStore/LoginOidc', { configuration: method.oidcAuthority, login: login });
    }

    /** Finalisation de la procédure d'authentification pour les autres types de SSO */
    private async handleSsoPartnerSignIn(): Promise<void>{
        //On n'a pas de login fournis dans l'url pour les partenaires, cette information est dans le token
        await this.signInUser("", this.context.UrlQueryParameters.token as string, this.context.UrlQueryParameters.authority as string);
    }

    /** Finalisation de la procédure d'authentification pour SSO Oidc*/
    private async handleSsoOidcSignIn(): Promise<void>{
        await this.context.Vue.$store.dispatch("AuthentificationStore/Load")
                .catch(err => {
                    console.error(err);
                    this.context.Vue.$bvToast.toast(this.context.Vue.$t('AnErrorOccured').toString(), { 
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                });

        /** On récupère la méthode d'authentification */
        const method: ConnectionMethod = await this.context.Vue.$store.getters['AuthentificationStore/GetConnectionMethod'];
        
        if( method && method.method === AuthentificationMethodEnum.Oidc && method.oidcAuthority) {
            /** On finalise la précédure OIDC */
            await this.context.Vue.$store.dispatch('OidcStore/HandleOidcCallback', method.oidcAuthority).catch(async err =>{
                    console.error(err);
                    this.context.Vue.$bvToast.toast(this.context.Vue.$t('AnErrorOccured').toString(), { // "Une erreur s'est produite."
                        title: this.context.Vue.$t('Error').toString(),
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                });
                await this.RedirectError();
            });

            /** On récupère les informaitons d'identité */
            const user: User = await this.context.Vue.$store.getters['OidcStore/GetUser'];
            /** On change l'interface visuel pour afficher l'avancement OIDC*/
            this.context.ShowSsoOidcInfo = true;

            await this.signInUser(user.profile.preferred_username, user.access_token, method.oidcAuthority.AuthorityKey);
        } else{
            /** 
             * Simple vérification, (URL avec paramètres GET bidons genre "mail=", "...=", etc ...) 
             * Peux ce produire, quand un utilisateur utilise une URL issue d'une ancienne campagne mail.
             * Peux ce poser, lorsque que le token retourné agit sur un login qui ne match pas.
             */
            console.error("Connexion Page : authentification method change between login and oicd callback");
            await this.context.Vue.$router.push({ name: 'Connexion' })
        }
    }

    private async signInUser(login: string, token: string, authKey: string ){
         /** Arguments pour l'authentification final grâce au token (Validation du token + Authentification Legacy) */
            const args: Dictionary<any> = {};
            args["Login"] = login;
            args["AuthKey"] = authKey;
            args["Token_to_validate"] = token;

            this.context.Vue.$store.dispatch("ShowLoadingMask", this.context.Vue.$t('LoginInProgress'));     // "Identification en cours"

            /** Indentification de l'utilisateur */
            await axios.post(API_URL + "Connexion/IdentSso", args).then(async (response) => {
                if (response && response.data) {
                    // Ajoute dans les cookies l'identifiant de la session
                    this.context.Vue.$cookies.set('access_token', response.data.access_token);
                    this.context.Vue.$cookies.set('access_token_timestamp', Date.now());

                    await this.context.Vue.$store.dispatch("SessionStore/SetIsSupervisor", response.data.isSupervisor);

                    // Traitement et redirection vers Master en cas d'une connexion cliente
                    if(response.data.connections) {
                        Vue.set(this.context, "redirect", "/Master");
                        this.context.Vue.HandleMessage(response.data.iK);
                    }
                    else {   // Liste des bases de données
                        this.context.ShowBddList = true;
                    }
                }
                else {
                    this.context.LoginFailed = true;
                    this.context.ShowPasswordForm = false;
                    this.context.Vue.$bvToast.toast(this.context.Vue.$t('PleaseRetry').toString(), {     // Veuillez saisir de nouveau votre identifiant et votre mot de passe ou contacter votre administrateur. Vos droits sont peut-être échus.
                        title: this.context.Vue.$t('UnableToConnect').toString(),            //"Connexion impossible",
                        autoHideDelay: 10000,
                        variant: "warning",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                    this.context.Vue.$store.dispatch('')
                    await this.RedirectError(true);
                }
            })
            /** ECHEC */
            .catch(async err => {
                console.error(err);
                this.context.Vue.$bvToast.toast(this.context.Vue.$t('AnErrorOccured').toString(), { // "Une erreur s'est produite."
                    title: this.context.Vue.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                await this.RedirectError();
            })
            /** CLEANUP */
            .finally(() => {
                this.context.Vue.$store.dispatch("HideLoadingMask", {});
            });
    }

    /** Redirige en cas d'érreur */
    private async RedirectError(forceLogout: boolean = false){
        /** Affiche une erreur. */
        this.context.ShowSsoOidcError = true;
        if(forceLogout){
            /** Redirige vers la page d'accueil après 5 secondes pour laisser l'utilisateur lire le message d'erreur. */
            setTimeout(async () => {
                await this.context.Vue.$store.dispatch('OidcStore/LogoutOidcIdp');
                await this.context.Vue.$router.push({ name: 'Connexion' })
            }, 10000)
        }else{
            /** Supprime les variables de session */
            await this.context.Vue.$store.dispatch('AuthentificationStore/ResetStorage');
            await this.context.Vue.$store.dispatch('AuthentificationStore/Reset');
            /** Vide le store pour relancer la procédure proprement. */
            await this.context.Vue.$store.dispatch('OidcStore/ResetSession');
            /** Redirige vers la page d'accueil après 5 secondes pour laisser l'utilisateur lire le message d'erreur. */
            setTimeout(async () => {
                await this.context.Vue.$router.push({ name: 'Connexion' })
            }, 10000)
        }
        
    }
    
    //#region CAS INGORE
    /** VOID */
    public ResetPassword(): void { /** Non proposé à l'utilisateur */ }

    /** VOID */
    public async SendMail(): Promise<void> { /** Non proposé à l'utilisateur */ }

    /** VOID */
    public async Abord(): Promise<void> { /** Non proposé à l'utilisateur */ }

    /** VOID */
    public About(): void { /** Non proposé à l'utilisateur */ }
    //#endregion CAS INGORE
}